/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Virtual_TourInputs */

const en_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual Tour`)
};

const es_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour virtual`)
};

const fr_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visite virtuelle`)
};

const de_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtuelle Tour`)
};

const ja_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バーチャルツアー`)
};

const zh_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虚拟导览`)
};

const ar_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جولة افتراضية`)
};

const id_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tur Virtual`)
};

const it_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour Virtuale`)
};

const ru_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виртуальный тур`)
};

const pt_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour Virtual`)
};

const ko_val_virtual_tour = /** @type {(inputs: Val_Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가상 투어`)
};

/**
* | output |
* | --- |
* | "Virtual Tour" |
*
* @param {Val_Virtual_TourInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_virtual_tour = /** @type {((inputs?: Val_Virtual_TourInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Virtual_TourInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_virtual_tour(inputs)
	if (locale === "es") return es_val_virtual_tour(inputs)
	if (locale === "fr") return fr_val_virtual_tour(inputs)
	if (locale === "de") return de_val_virtual_tour(inputs)
	if (locale === "ja") return ja_val_virtual_tour(inputs)
	if (locale === "zh") return zh_val_virtual_tour(inputs)
	if (locale === "ar") return ar_val_virtual_tour(inputs)
	if (locale === "id") return id_val_virtual_tour(inputs)
	if (locale === "it") return it_val_virtual_tour(inputs)
	if (locale === "ru") return ru_val_virtual_tour(inputs)
	if (locale === "pt") return pt_val_virtual_tour(inputs)
	return ko_val_virtual_tour(inputs)
});